import _pt from "prop-types";
import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var Cog = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$ariaHidden = _ref['aria-hidden'],
      ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      title = _ref.title,
      titleId = _ref.titleId;
  var numericSize = size === 'medium' ? 16 : size === 'small' ? 14 : 12;
  return ___EmotionJSX("svg", {
    viewBox: "0 0 18 18",
    "aria-hidden": ariaHidden,
    className: className,
    height: numericSize,
    ref: ref,
    role: "img",
    width: numericSize,
    "aria-labelledby": titleId
  }, title === undefined ? ___EmotionJSX("title", {
    id: titleId
  }, 'Cog') : title ? ___EmotionJSX("title", {
    id: titleId
  }, title) : null, ___EmotionJSX("path", {
    fill: color,
    d: "M7.186 15.621a3.047 3.047 0 013.628 0l.25.186a7.053 7.053 0 001.29-.535l.045-.308a3.047 3.047 0 012.565-2.565l.308-.046c.22-.41.4-.842.535-1.289l-.186-.25a3.047 3.047 0 010-3.628l.186-.25a7.053 7.053 0 00-.535-1.29l-.308-.045A3.047 3.047 0 0112.4 3.036l-.046-.308c-.41-.22-.842-.4-1.289-.535l-.25.186a3.047 3.047 0 01-3.628 0l-.25-.186a7.053 7.053 0 00-1.29.535l-.045.308A3.047 3.047 0 013.036 5.6l-.308.046c-.22.41-.4.842-.535 1.289l.186.25a3.047 3.047 0 010 3.628l-.186.25c.136.447.315.879.535 1.29l.308.045A3.047 3.047 0 015.6 14.964l.046.308c.41.22.842.4 1.289.535l.25-.186zM7.388 18a9.092 9.092 0 01-3.612-1.497l-.184-1.24a1.016 1.016 0 00-.856-.855l-1.24-.184A9.092 9.092 0 010 10.612l.747-1.007c.266-.36.266-.85 0-1.21L0 7.388a9.092 9.092 0 011.497-3.612l1.24-.184c.442-.066.789-.413.855-.856l.184-1.24A9.092 9.092 0 017.388 0l1.007.747c.36.266.85.266 1.21 0L10.612 0a9.092 9.092 0 013.612 1.497l.184 1.24c.066.442.413.789.856.855l1.24.184A9.092 9.092 0 0118 7.388l-.747 1.007c-.266.36-.266.85 0 1.21L18 10.612a9.092 9.092 0 01-1.497 3.612l-1.24.184c-.442.066-.789.413-.855.856l-.184 1.24A9.092 9.092 0 0110.612 18l-1.007-.747a1.016 1.016 0 00-1.21 0L7.388 18zM9 13.063a4.063 4.063 0 110-8.126 4.063 4.063 0 010 8.126zm0-2.032A2.031 2.031 0 109 6.97a2.031 2.031 0 000 4.062z",
    fillRule: "evenodd"
  }));
});
Cog.propTypes = process.env.NODE_ENV !== "production" ? {
  'aria-hidden': _pt.bool,
  className: _pt.string,
  color: _pt.string,
  size: _pt.oneOf(['xsmall', 'small', 'medium']),
  title: _pt.string,
  titleId: _pt.string
} : {};
export default Cog;